/* The variant template uses the existing gallery's HTML video branch.
 * Keep the legacy overlay behavior below for other templates and CPQ products.
 */
function gkUsesVariantVideo() {
  var gke = window.gke;
  if (!gke || !gke.variantMedia || !gke.product) return false;
  var cpq = gke.product.cpq || {};
  var custom = gke.product.metafields && gke.product.metafields.IsCustom;
  return custom !== true && custom !== 'true' &&
    cpq.isCustomized !== true && cpq.isCustomized !== 'true' &&
    !(cpq.configurationImages && cpq.configurationImages.length);
}

(function () {
  'use strict';
  if (!gkUsesVariantVideo()) return;

  // Register before Vue mounts. The bundled desktop watcher dereferences an
  // image on every slide; video slides have no image or zoom target.
  if (typeof window.require === 'function') {
    var gallery;
    try { gallery = window.require(408); } catch (error) { return; }
    gallery = gallery.default || gallery;
    if (gallery.watch && !gallery.__variantVideoInstalled) {
      gallery.__variantVideoInstalled = true;
      var originalActive = gallery.watch.activeImage;
      gallery.watch.activeImage = function (index) {
        if (!gkUsesVariantVideo()) return originalActive.call(this, index);
        this.showZoom = false;
        this.$nextTick(function () {
          if (this.isMobile) {
            var carousel = this.$refs.carousel;
            if (carousel && carousel.swiper) carousel.swiper.slideTo(index);
            return;
          }
          // The template's CSS reserves one frame for every media type. Using
          // each selected item's height here makes video/image changes reflow.
          this.$el.style.minHeight = '';
          if (this.$refs.result) {
            this.$refs.result.style.backgroundImage = this.isImage(this.images[index] || '')
              ? 'url("' + this.images[index] + '")' : '';
          }
        });
      };
      var originalImages = gallery.watch.images;
      gallery.watch.images = function () {
        if (typeof originalImages === 'function') originalImages.apply(this, arguments);
        if (gkUsesVariantVideo()) {
          this.activeImage = 0;
          this.showZoom = false;
          this.$nextTick(function () {
            if (this.$refs.carousel && this.$refs.carousel.swiper) {
              this.$refs.carousel.swiper.slideTo(0);
            }
          });
        }
      };
    }
  }

  function init() {
    var productPage = document.querySelector('.product-page');
    if (productPage && productPage.classList) productPage.classList.add('gk-variant-media-layout');
    var prepared = new WeakSet();
    var tracked = new Set();
    var playback = new WeakMap();
    var scheduled = false;

    function sync() {
      scheduled = false;
      if (productPage && productPage.classList) productPage.classList.toggle('gk-variant-media-layout', gkUsesVariantVideo());
      if (!gkUsesVariantVideo()) return;
      // Pause players detached when a color/size change replaces the gallery.
      tracked.forEach(function (video) {
        if (!video.isConnected) { video.pause(); tracked.delete(video); }
      });
      document.querySelectorAll('.product-thumbnails-wrapper video, .product-image__main-photos video').forEach(function (video) {
        var thumbnail = video.closest('.product-thumbnails-wrapper');
        if (!prepared.has(video)) {
          prepared.add(video);
          if (thumbnail) {
            var wasAuto = video.hasAttribute('autoplay') || video.hasAttribute('loop');
            video.pause();
            video.removeAttribute('autoplay');
            video.removeAttribute('loop');
            video.controls = false;
            video.muted = true;
            video.style.pointerEvents = 'none';
            // Poster avoids downloading/seeking video for a thumbnail.
            if (!video.getAttribute('poster')) {
              var seek = function () {
                if (Number.isFinite(video.duration) && video.duration > 0) {
                  try { video.currentTime = Math.min(3, video.duration / 2); } catch (error) {}
                }
              };
              if (video.readyState >= 1) seek();
              else video.addEventListener('loadedmetadata', seek, { once: true });
            }
            var li = video.closest('li');
            if (li && !(video.getAttribute('poster') || '').includes('sizechart')) {
              var old = li.querySelector('.thumb-video-overlay');
              if (old) old.remove();
              var overlay = document.createElement('span');
              overlay.className = 'thumb-video-overlay';
              overlay.setAttribute('aria-hidden', 'true');
              if (wasAuto) {
                overlay.textContent = '360°';
              } else {
                var thumbnailIcon = document.createElement('img');
                thumbnailIcon.src = "//staging-shop.gkelite.com/cdn/shop/t/60/assets/icon-play.svg?v=136672280994089585861721658846";
                thumbnailIcon.alt = '';
                thumbnailIcon.style.cssText = 'display:block;width:100%;height:100%;pointer-events:none';
                overlay.appendChild(thumbnailIcon);
              }
              overlay.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:40px;height:40px;display:flex;align-items:center;justify-content:center;pointer-events:none;color:black;z-index:5';
              li.style.position = 'relative';
              li.appendChild(overlay);
              var link = li.querySelector('a.carousel-video-link');
              if (link) link.setAttribute('aria-label', 'View product video');
            }
          } else {
            tracked.add(video);
            video.controls = false;
            video.removeAttribute('controls');
            // Playback is started only for the active slide, not every video
            // mounted by Vue. Muting allows inline autoplay on mobile browsers.
            video.muted = true;
            video.defaultMuted = true;
            video.loop = true;
            video.setAttribute('playsinline', '');
            video.style.width = '100%';
            video.style.height = 'auto';
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'gk-video-toggle swiper-no-swiping';
            button.style.cssText = 'position:absolute;bottom:12px;left:15px;z-index:5;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center';
            var controlIcon = document.createElement('img');
            controlIcon.alt = '';
            controlIcon.setAttribute('aria-hidden', 'true');
            controlIcon.style.cssText = 'display:block;width:100%;height:100%;pointer-events:none';
            button.appendChild(controlIcon);
            var container = video.parentElement;
            container.style.position = 'relative';
            container.appendChild(button);
            var state = { visible: false };
            playback.set(video, state);
            function updateButton() {
              controlIcon.src = video.paused
                ? "//staging-shop.gkelite.com/cdn/shop/t/60/assets/icon-play.svg?v=136672280994089585861721658846"
                : "//staging-shop.gkelite.com/cdn/shop/t/60/assets/icon-pause.svg?v=142839467943666585681789584594";
              button.setAttribute('aria-label', video.paused ? 'Play product video' : 'Pause product video');
            }
            function play() {
              var pending = video.play();
              if (pending && pending.catch) pending.catch(updateButton);
            }
            state.play = play;
            button.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              if (video.paused) play();
              else video.pause();
            });
            video.addEventListener('play', function () {
              // A pending play request can finish after the slide was hidden.
              if (!state.visible || !video.isConnected) { video.pause(); return; }
              tracked.forEach(function (other) { if (other !== video) other.pause(); });
              updateButton();
            });
            video.addEventListener('pause', updateButton);
            updateButton();
          }
        }
        if (!thumbnail) {
          var slide = video.closest('.swiper-slide');
          var item = video.closest('li');
          var visible = !document.hidden && (slide
            ? slide.classList.contains('swiper-slide-active')
            : !!(item && item.classList.contains('active')));
          var state = playback.get(video);
          if (!visible) {
            state.visible = false;
            video.pause();
          } else if (!state.visible) {
            state.visible = true;
            state.play();
          }
          // Do not restart a manually paused video on unrelated DOM updates.
        }
      });
    }
    function schedule() {
      if (!scheduled) { scheduled = true; window.requestAnimationFrame(sync); }
    }
    // Observe immediately, even if the first variant has only images. Vue may
    // replace gallery nodes entirely on later variant changes.
    var observer = new MutationObserver(schedule);
    observer.observe(document.querySelector('.product-page') || document.body,
      { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('visibilitychange', schedule);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

document.addEventListener("DOMContentLoaded", () => {
  if (gkUsesVariantVideo()) return;
  if (window.innerWidth < 768) {
    console.log("[GK Video] Skipping overlays on mobile");
    return;
  }
  function waitForVideos(attempts = 40) {
    const videos = document.querySelectorAll(".product-thumbnails-wrapper video");
    if (!videos.length) {
      if (attempts > 0) return setTimeout(() => waitForVideos(attempts - 1), 300);
      console.warn("[GK Video] No video elements found after waiting.");
      return;
    }

    console.log(`[GK Video] Found ${videos.length} video(s), injecting overlays...`);
    injectOverlays();
    observeThumbnails();
  }

  function observeThumbnails() {
    const gallery = document.querySelector(".product-thumbnails-wrapper");
    if (!gallery) return;
    const observer = new MutationObserver(() => injectOverlays());
    observer.observe(gallery, { childList: true, subtree: true });
  }

  function injectOverlays() {
    const thumbs = document.querySelectorAll(".product-thumbnails-wrapper li");

    thumbs.forEach((li) => {
      if (li.querySelector(".thumb-video-overlay")) return;

      const video = li.querySelector("video");
      if (!video) return;

      const posterSrc = video.getAttribute("poster") || "";

      // 🧠 skip overlays on size chart thumbnails
      if (posterSrc.includes("sizechart")) return;

      // Detect if this is an autoplay/loop video
      const wasAuto = video.hasAttribute("autoplay") || video.hasAttribute("loop");

      // Freeze playback and display only the first frame
      video.pause();
      video.removeAttribute("autoplay");
      video.removeAttribute("loop");
      video.currentTime = 3;
      video.style.pointerEvents = "none";
  

      // 🌀 Add the appropriate overlay (always 360° if was auto)
      const overlay = document.createElement("div");
      overlay.className = "thumb-video-overlay";
      overlay.innerHTML = wasAuto
        ? `<img src="//staging-shop.gkelite.com/cdn/shop/t/60/assets/icon-360.svg?v=103524877046612524271772050623" alt="360° View" />`
        : `<img src="//staging-shop.gkelite.com/cdn/shop/t/60/assets/icon-play.svg?v=136672280994089585861721658846" alt="Play Video" />`;

      li.style.position = "relative";

      overlay.style.cssText = `
      position: absolute;  top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 48px;
      height: 48px;
      z-index: 5;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      `;


      const icon = overlay.querySelector("img");
      icon.style.cssText = `
        width:100%;
        height:100%;
        opacity:0.9;
        transition:opacity 0.2s ease;
      `;

      li.appendChild(overlay);
    });
  }

  waitForVideos();
});
